import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/admin_dashboard/show.vue'

export default class extends Controller {
  static values = { planGroups: Array, plans: Array }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    this.vue = createApp(App, {
      planGroups: this.planGroupsValue,
      plans: this.plansValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
